import { EntityAudit } from "@modernary/mui/components/audit";
import { type RouterOptions, RouterView } from "vue-router";

const names = {
  users: "User.Users",
  list: "User.UserList",
  view: "User.UserView",
  // new: "User.UserNew",
  base: "User.UserBase",
  // audit: "User.UserAudit",
  // edit: "User.UserEdit",
};

export { names as userRouteNames };

const usersRoutes: RouterOptions["routes"] = [
  {
    path: "/user",
    name: names.users,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Users" },
        component: () => import("@/views/user/UserList.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/user/UserBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "User View" },
            component: () => import("@/views/user/UserView.vue"),
          },
          // {
          //   path: "activity",
          //   name: names.userAudit,
          //   meta: { title: "User Audit Activity" },
          //   component: {
          //     render: () => <EntityAudit entityType="User" />,
          //   },
          // },
        ],
      },
    ],
  },
];

export default usersRoutes;
